export default "__VITE_ASSET__kO$t2im4__"